import { render } from "./columnSetting.vue?vue&type=template&id=28ecb02a&scoped=true"
import script from "./columnSetting.vue?vue&type=script&lang=js"
export * from "./columnSetting.vue?vue&type=script&lang=js"

import "./columnSetting.vue?vue&type=style&index=0&id=28ecb02a&scoped=true&lang=css"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ecb02a"]])

export default __exports__